<template>
  <div class="wrap">
    <div class="main_con fadeInUp animated" v-if="productDetailData">
      <div class="breadcrumb_con">
        <el-breadcrumb separator="/">
          <i class="el-icon-location-outline left icon-location"></i>
          <span class="left">{{ $t("common.CurrentLocation") }}：</span>
          <el-breadcrumb-item
            ><router-link to="/Home">{{
              $t("common.Glang")
            }}</router-link></el-breadcrumb-item
          >
          <el-breadcrumb-item
            ><router-link to="/Products">{{
              $t("top.Products")
            }}</router-link></el-breadcrumb-item
          >
          <el-breadcrumb-item
            ><router-link
              :to="'/Products?id=' + productDetailData.categories_id"
              >{{ productDetailData.categories_name }}</router-link
            ></el-breadcrumb-item
          >
          <el-breadcrumb-item>{{
            $t("common.ProductsDetail")
          }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-divider></el-divider>
      <div class="body_con">
        <div class="products_con">
          <div class="product_detail">
            <div class="product_left_con">
              <div class="spec-preview">
                <img :src="img_head_url + productDetailData.pro_img[img_index]" />
                <div class="event" @mousemove="handler"></div>
                <div class="big">
                  <img
                    :src="img_head_url + productDetailData.pro_img[img_index]"
                    ref="big"
                  />
                </div>
                <div class="mask" ref="mask"></div>
              </div>
              <ul>
                <li
                  v-for="(item, index) in productDetailData.pro_img"
                  :key="'pro_img' + index"
                  :class="index == img_index ? 'active' : ''"
                  @click="changeImg(index)"
                >
                  <img
                    :src="img_head_url + item"
                    style="width: 100%; height: 100%"
                  />
                </li>
              </ul>
              <!-- <el-carousel
                class="el-carousel"
                height="400px"
                trigger="click"
                arrow="always"
                :interval="5000"
              >
                <el-carousel-item
                  v-for="(item, index) in productDetailData.pro_img"
                  :key="'pro_img' + index"
                >
                  <img
                    :src="img_head_url + item"
                    style="width: 400px; height: 400px"
                    @mouseenter="show = true"
                    @mouseout="show = false"
                  />
                </el-carousel-item>
              </el-carousel> -->
            </div>
            <div class="product_right_con">
              <div class="products_name">
                {{ productDetailData.title
                }}<span class="products_categories"
                  >_{{ productDetailData.categories_name }}</span
                >
              </div>
              <div
                style="white-space: pre-wrap; margin-bottom: 20px"
                v-html="productDetailData.text"
              ></div>
              <div style="margin-bottom: 20px;" v-if="productDetailData.annex_url != null && productDetailData.annex_url!=''"><a :href="img_head_url+productDetailData.annex_url" target="_blank" style="color:#478bb2;text-decoration: underline;">{{ $t("common.LearnMore") }}</a></div>
              <div
                class="products_details"
                v-if="productDetailData.pro_text.length > 0"
              >
                {{ $t("products.ModelName") }}
              </div>
              <div
                class="parameter"
                v-for="(item, index) in productDetailData.pro_text"
                :key="'pro_text' + index"
              >
                <div class="parameter_name">{{ item.title }}</div>
                <div class="parameter_value">{{ item.content }}</div>
              </div>
              <router-link to="/Contact?from=productdetail">
                <div class="message">{{ $t("products.Message") }}</div>
              </router-link>
            </div>
          </div>
          <div class="related_products" v-if="other_pro_list.length > 0">
            {{ $t("products.RelatedProducts") }}
          </div>
          <div class="related_products_con">
            <el-row :gutter="20">
              <el-col
                :span="6"
                v-for="(item, index) in other_pro_list"
                :key="'other_pro_list' + index"
              >
                <router-link :to="'/ProductDetail?id=' + item.id">
                  <el-card class="card_con">
                    <div class="products_pic">
                      <img class="img" :src="img_head_url + item.src" />
                    </div>
                    <div class="products_name">{{ item.title }}</div>
                    <div class="type_name">{{ item.categories_name }}</div>
                  </el-card>
                </router-link>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  // 监听,当路由发生变化的时候执行
  watch: {
    $route (to, from) {
      var that = this
      console.log(to.query.id)
      that.id = to.query.id || 0
      that.getProductDetailData()
    }
  },
  components: {},
  data () {
    return {
      id: 0,
      img_head_url: '',
      lang: localStorage.lang || 'cn',
      productDetailData: '',
      other_pro_list: [],
      img_index: 0
    }
  },
  created () {
    var that = this
    that.id = this.$route.query.id
    that.getProductDetailData()
  },
  methods: {
    getProductDetailData () {
      var that = this
      var json = {
        lang: that.lang,
        id: that.id
      }
      var url = '/api/get_product_detail'
      that.$lcommon.ajaxRequest('post', url, json, function (res) {
        console.log(res)
        if (res.meta.status === 200) {
          that.productDetailData = res.data.pro_detail
          that.other_pro_list = res.data.other_pro_list
          that.img_head_url = res.img_head_url
        }
      })
    },
    imgSrc (src) {
      var that = this
      return that.img_head_url + src
    },
    gotoDetail (id) {
      this.$router.push({ path: '/ProductDetail', query: { id: id } })
      this.$router.go(0)
    },
    handler (event) {
      const big = this.$refs.big
      // 获取遮罩层dom实现遮罩层跟随鼠标位置移动
      const mask = this.$refs.mask
      // offsetX：鼠标坐标到元素的左侧的距离
      // offsetWidth 除了外边距(margin)以外，所有的宽度(高度)之和
      let left = event.offsetX - mask.offsetWidth / 2
      // offsetY：鼠标坐标到元素的顶部的距离
      // offsetHeight:元素的像素高度 包含元素的垂直内边距和边框,水平滚动条的高度,且是一个整数
      let top = event.offsetY - mask.offsetHeight / 2
      //  约束范围,保证光标在div范围内，都是以父盒子div为参考对象的
      if (left <= 0) left = 0
      if (left >= mask.offsetWidth) left = mask.offsetWidth
      if (top <= 0) top = 0
      if (top >= mask.offsetHeight) top = mask.offsetHeight
      //  修改元素的left|top属性值
      // 遮罩层
      mask.style.left = left + 'px'
      mask.style.top = top + 'px'
      // 放大镜，你向左移动鼠标，图片就是向右移动，运动方向是相反的
      big.style.left = -2 * left + 'px'
      big.style.top = -2 * top + 'px'
    },
    changeImg (index) {
      var that = this
      that.img_index = index
    }
  }
}
</script>
<style lang="less" scoped>
.products_con {
  width: 1200px;
  margin: 0 auto 20px;
  position: relative;
  text-align: left;
  padding: 50px 0;
}
.el-carousel {
  width: 100%;
}
.products_con .product_detail {
  display: flex;
  margin-bottom: 20px;
}
.products_con .product_detail .product_left_con {
  width: 400px;
  height: 600px;
  border-radius: 4px;
  // border: 1px solid #ebeef5;
  margin-right: 50px;
}
.products_con .product_detail .product_right_con {
  flex: 1;
}
.product_right_con .products_name {
  color: #333;
  font-size: 16px;
  font-weight: bold;
}
.product_right_con .products_name::after {
  display: block;
  content: "";
  width: 100%;
  height: 1px;
  margin: 20px 0;
  background-color: #999;
}
.product_right_con .products_categories {
  color: #999;
  display: inline-block;
}
.product_right_con .products_details {
  color: #333;
  font-size: 16px;
  font-weight: bold;
}
.product_right_con .products_details::after {
  display: block;
  content: "";
  width: 100%;
  height: 1px;
  margin: 20px 0;
  background-color: #999;
}
.product_right_con .parameter {
  border-bottom: 1px solid #ebeef5;
  padding: 10px 0;
}
.parameter .parameter_name {
  color: #999;
  display: inline-block;
}
.parameter .parameter_value {
  color: #333;
  display: inline-block;
  margin-left: 10px;
}
.related_products {
  color: #333;
  font-size: 16px;
  font-weight: bold;
}
.related_products::after {
  display: block;
  content: "";
  width: 100%;
  height: 1px;
  margin: 20px 0;
  background-color: #999;
}
.related_products_con .el-col {
  margin-bottom: 20px;
}
.related_products_con .card_con:hover {
  background-color: rgba(60, 66, 124, 0.7);
}
.related_products_con .type_name {
  font-size: 12px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.related_products_con .card_con:hover .type_name {
  color: #fff;
}
.related_products_con .products_name {
  font-size: 14px;
  color: #333;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.related_products_con .card_con:hover .products_name {
  color: #fff;
}
.related_products_con .products_pic {
  height: 162px;
}
.related_products_con .products_pic .img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  max-width: 100%;
  vertical-align: top;
  border: 0;
}
.message {
  margin-top: 10px;
  color: #279fc9;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  transition: 0.1s;
  font-weight: 500;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
}
.message:hover {
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}

.spec-preview {
  position: relative;
  width: 400px;
  height: 400px;
  border: 1px solid #ccc;
  cursor: move;
}
.spec-preview > img {
  width: 100%;
  height: 100%;
}

.event {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 998;
}
.mask {
  width: 50%;
  height: 50%;
  background-color: rgba(0, 255, 0, 0.3);
  position: absolute;
  left: 0;
  top: 0;
  display: none;
  z-index: 1;
  opacity: 0.4;
  background: url(../assets/img/mask.png) repeat scroll 0 0 transparent !important;
}

.big {
  width: 100%;
  height: 100%;
  position: absolute;
  top: -1px;
  left: 440px;
  // border: 1px solid rgb(212, 11, 11);
  /* //把下面这行代码去掉，试着理解为什么上面需要乘以-2 */
  overflow: hidden;
  z-index: 998;
  display: none;
  background: white;
}
.big img {
  /* 这里的宽高实现放大两倍的效果 */
  width: 200%;
  max-width: 200%;
  height: 200%;
  position: absolute;
  left: 0;
  top: 0;
}
.event:hover + .big,
.event:hover ~ .mask {
  display: block;
}
.product_left_con ul {
  margin-top: 12px;
}
.product_left_con ul li {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  display: inline-block;
  height: 68px;
  width: 68px;
  border-radius: 6px;
  position: relative;
  z-index: 0;
  cursor: pointer;
  margin-left: 9px;
}
.product_left_con ul li:nth-child(6n + 1) {
  margin-left: 0;
}
.product_left_con ul li.active:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  border-radius: 6px;
  border: 4px solid #f9f7f3;
  z-index: 1;
}

.product_left_con ul li.active:after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  border-radius: 6px;
  border: 1px solid #3c427c;
  z-index: 2;
}
</style>
